<template>
  <div>
    <div class="foot">
      <div
        class="button"
        @click="onSubmit"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    onSubmit() {
      this.$emit('submit')
    }
  }
}
</script>
<style lang="scss" scoped>
.foot {
  width: 375px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .button {
    width: 345px;
    height: 40px;
    background: linear-gradient(90deg, #70a7ff 0%, #3d6eff 100%);
    border-radius: 6px;
    margin: 10px auto 10px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
